import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';


export class AuthHttpService {

	public baseUrl: string = process.env.GATEWAY_URL;

	private token: string = '';

	constructor(private http: Http) { }

	public setAuthToken(value: string): void {
		this.token = value;
	}

	public get(url: string, queryParams?: URLSearchParams, reqHeaders?: Headers) {
		const reqOptions = {
			headers: this.getAuthHeader(reqHeaders),
			search: queryParams ? queryParams : null
		};

		return this.http.get(this.baseUrl + url, new RequestOptions(reqOptions));
	}

	public post(url: string, body: string, queryParams?: URLSearchParams, reqHeaders?: Headers) {
		const reqOptions = {
			headers: this.getAuthHeader(reqHeaders),
			search: queryParams ? queryParams : null
		};

		return this.http.post(this.baseUrl + url, body, new RequestOptions(reqOptions));
	}

	public put(url: string, body: string, queryParams?: URLSearchParams, reqHeaders?: Headers) {
		const reqOptions = {
			headers: this.getAuthHeader(reqHeaders),
			search: queryParams ? queryParams : null
		};

		return this.http.put(this.baseUrl + url, body, new RequestOptions(reqOptions));
	}

	public patch(url: string, body: string, queryParams?: URLSearchParams, reqHeaders?: Headers) {
		const reqOptions = {
			headers: this.getAuthHeader(reqHeaders),
			search: queryParams ? queryParams : null
		};

		return this.http.patch(this.baseUrl + url, body, new RequestOptions(reqOptions));
	}

	public delete(url: string, queryParams?: URLSearchParams, reqHeaders?: Headers) {
		const reqOptions = {
			headers: this.getAuthHeader(reqHeaders),
			search: queryParams ? queryParams : null
		};

		return this.http.delete(this.baseUrl + url, new RequestOptions(reqOptions));
	}

	private getAuthHeader(recievedHeaders?: Headers): Headers {
		let headers = recievedHeaders ? recievedHeaders : new Headers();
		headers.append('Authorization', 'Guest ' + this.token);
		headers.append('Content-Type',  'application/json');

		return headers;
	}
static ctorParameters() { return [ { type: Http } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/guest/services/auth-http.service.ts